<template>
  <AntFormItem class="select">
    <label :for="name">
      {{ label }}
    </label>
    <AntSelect
      v-bind="$attrs"
      v-on="$listeners"
      :placeholder="placeholder"
      v-decorator="[name, {
        initialValue,
        preserve,
      }]"
      allowClear
    >
      <template v-if="options">
        <AntSelectOption
          v-for="{ value, label } in options"
          :key="value"
        >
          {{ label }}
        </AntSelectOption>
      </template>
      <slot v-else />
    </AntSelect>
  </AntFormItem>
</template>

<script>
import {
  Select as AntSelect,
  Form as AntForm,
} from 'ant-design-vue';

import formFieldMixin from '@/common/mixins/form-field';
import { isArrayOfShapes } from '@/common/prop-validators';

export default {
  name: 'Select',
  components: {
    AntSelect,
    AntSelectOption: AntSelect.Option,
    AntFormItem: AntForm.Item,
  },
  mixins: [formFieldMixin],
  props: {
    placeholder: {
      type: String,
      default: 'Select a value',
    },
    initialValue: {
      type: [String, Number],
    },
    options: {
      type: Array,
      required: false,
      default: null,
      validator: isArrayOfShapes({
        value: [String, Number],
        label: String,
      }),
    },
    preserve: {
      type: Boolean,
      default: true,
    },

  },
};
</script>

<style lang="scss">
  .select {
    label {
      color: $primary;
      font-size: 14px;
      font-weight: 600;
    }

    .ant-form-item-control {
      line-height: 38px;
    }

    .ant-select-selection {
      &__rendered {
        height: 100%;
        margin: 0 20px;
      }

      &__placeholder {
        color: $gray;
        font-size: 13px;
        font-weight: 500;
        letter-spacing: .3px;
        opacity: .41;
      }

      &--single {
        border-radius: 12px;
        border: 1px solid $grayLightest;
        height: 50px;
      }
    }

    .ant-select-selection-selected-value {
      color: $primary;
      font-size: 13px;
      font-weight: 500;
      letter-spacing: .3px;
      line-height: 50px;
      margin-right: 20px;
    }
  }

  .ant-form-item-control.has-success .ant-select-selection {
    background-color: rgba($accent, .1);
    border: 1px solid $accent;
  }
</style>
